// GENERATED from supabase/functions/_shared/facts/sharedOptions.ts
// by scripts/generateSharedOptions.js (npm run sync:options). Do not edit.

// supabase/functions/_shared/facts/sharedOptions.ts
//
// ONE definition of the option lists the shared tax foundation uses
// (ticket 041-foundation2a, slice 1). Edge functions import this file.
// The frontend gets a GENERATED copy: src/lib/sharedOptions.js, written by
// `npm run sync:options` (scripts/generateSharedOptions.js). Never edit the
// generated copy by hand; a Jest test fails if it is stale.
//
// WHY A GENERATED COPY: Create React App cannot import a .ts file from
// outside src/. See project_docs/shared_facts_foundation.md.
//
// RULES FOR THIS FILE (the generator and the Jest test depend on them):
//   - DATA ONLY: plain `export const NAME = [ ... ] as const` declarations.
//   - No imports, no functions, no type annotations (the trailing
//     "as const" marker is the only TypeScript syntax allowed).
//   - Types and helpers live in factTypes.ts / householdFacts.ts.
//
// Labels are copied from src/lib/slotConfig.js (the canonical copy). The
// older copies (slotConfig.js, useCalculatorForm.js COMUNIDAD_OPTIONS,
// comunidadLabels.ts) are NOT re-pointed in slice 1; src/lib/sharedOptions.test.js
// pins them against this file and lists every known divergence.

export const COMUNIDAD_OPTIONS = [
  { value: 'andalucia',          label: 'Andalucía' },
  { value: 'aragon',             label: 'Aragón' },
  { value: 'asturias',           label: 'Asturias' },
  { value: 'baleares',           label: 'Illes Balears' },
  { value: 'canarias',           label: 'Canarias' },
  { value: 'cantabria',          label: 'Cantabria' },
  { value: 'castilla_la_mancha', label: 'Castilla-La Mancha' },
  { value: 'castilla_leon',      label: 'Castilla y León' },
  { value: 'cataluna',           label: 'Catalunya' },
  { value: 'extremadura',        label: 'Extremadura' },
  { value: 'galicia',            label: 'Galicia' },
  { value: 'la_rioja',           label: 'La Rioja' },
  { value: 'madrid',             label: 'Comunidad de Madrid' },
  { value: 'murcia',             label: 'Región de Murcia' },
  { value: 'navarra',            label: 'Navarra' },
  { value: 'pais_vasco',         label: 'País Vasco' },
  { value: 'valencia',           label: 'Comunitat Valenciana' },
]

// Foral territories (own tax authority, outside the national IRPF rules).
// Ticket 061: the intake shows a notice for these; the person continues.
// Data only; no function reads it.
export const FORAL_COMUNIDAD_OPTIONS = [
  { value: 'pais_vasco', label: 'País Vasco' },
  { value: 'navarra',    label: 'Navarra' },
]

// Ticket 061 (John's named exception to the facts-only rule, D-M1): the
// Advisor Intake stores "I moved to Spain before <last calendar year>" as this
// placeholder date in household.move_date. It is NOT a real move date. Every
// reader must treat a move date older than the cutoff year as "before <year>",
// never display it as a date. The only place this literal is written.
export const MOVE_DATE_BEFORE_CUTOFF = '1900-01-01'

// Canonical marital status. The first five are what the Snapshot asks.
// 'not_married' is the honest home for the Calculator's coarse answer
// "Single, separated, widowed, or divorced" (plan OQ3): it records that the
// person is not married without claiming which of the finer states applies.
export const MARITAL_STATUS_OPTIONS = [
  { value: 'married',            label: 'Married' },
  { value: 'civil_partnership',  label: 'Civil partnership (pareja de hecho)' },
  { value: 'single',             label: 'Single' },
  { value: 'separated_divorced', label: 'Separated or divorced' },
  { value: 'widowed',            label: 'Widowed' },
  { value: 'not_married',        label: 'Not married (not specified further)' },
]

// INPUT direction only: the three values the live Calculator form stores in
// calculator_sessions.session_payload.profile_facts.marital_status, mapped to
// the canonical vocabulary above.
export const MARITAL_LEGACY_CALCULATOR_MAP = [
  { legacy: 'single',      canonical: 'not_married' },
  { legacy: 'married',     canonical: 'married' },
  { legacy: 'civil_union', canonical: 'civil_partnership' },
]

export const CITIZENSHIP_STATUS_OPTIONS = [
  { value: 'us_citizen', label: '🇺🇸 US citizen (including dual citizens)' },
  { value: 'green_card', label: '🇺🇸 US Green Card holder' },
  { value: 'eu_citizen', label: '🇪🇺 EU citizen (non-US)' },
  { value: 'other',      label: 'Other nationality' },
]

// The Snapshot's fourth choice, 'not_sure', is NOT a value here: it is the
// completeness status "unknown" (see factTypes.ts).
export const ASSET_SPLIT_OPTIONS = [
  { value: 'roughly_equal',   label: 'Roughly equal between both' },
  { value: 'one_spouse_more', label: 'One spouse holds significantly more' },
  { value: 'all_one_spouse',  label: "Almost all in one spouse's name" },
]

export const BECKHAM_STATUS_OPTIONS = [
  { value: 'not_active', label: 'No' },
  { value: 'active',     label: 'Yes' },
]

// engineAge is the representative number the Calculator form stores and the
// IRPF engine reads (useCalculatorForm.js AGE_OPTIONS).
export const AGE_BAND_OPTIONS = [
  { value: 'under_65',  label: 'Under 65',    engineAge: 64 },
  { value: '65_to_74',  label: '65 to 74',    engineAge: 67 },
  { value: '75_plus',   label: '75 or older', engineAge: 76 },
]

// The Calculator's actual question: "Were you a Spanish tax resident this year?"
export const RESIDENT_SELF_REPORT_OPTIONS = [
  { value: 'resident',     label: 'Spanish tax resident' },
  { value: 'non_resident', label: 'Not a Spanish tax resident' },
]

// Derived Snapshot vocabularies (slotConfig.js). Kept here so adapters have
// one definition to emit from. They are never stored in assessment_facts.
export const SPAIN_RESIDENCY_STATUS_OPTIONS = [
  { value: 'resident_full_year',    label: '🇪🇸 Resident — full year' },
  { value: 'resident_partial_year', label: '🇪🇸 Resident — part of year' },
  { value: 'non_resident',          label: 'Not a resident this year' },
  { value: 'uncertain',             label: 'Not sure' },
]

export const RESIDENCY_YEAR_TYPE_OPTIONS = [
  { value: 'full_year_spain', label: '🇪🇸 Spain only — full year' },
  { value: 'full_year_us',    label: '🇺🇸 US only — full year' },
  { value: 'split_year',      label: '🇺🇸 + 🇪🇸 Both — moved during the year' },
]

// Which product or person supplied a fact (optional tag on each fact).
export const FACT_SOURCE_OPTIONS = [
  { value: 'snapshot',   label: 'Snapshot' },
  { value: 'calculator', label: 'Calculator' },
  { value: 'intake',     label: 'Advisor intake (client)' },
  { value: 'advisor',    label: 'Advisor' },
]

// ═══════════════════════════════════════════════════════════════════════════
// INCOME DOMAIN (ticket 044-foundation2b-income, slice 2)
// ═══════════════════════════════════════════════════════════════════════════
// Canonical income names are the Calculator's own (calculatorTypes.ts
// IncomeType / IncomeSubtype); labels are copied from src/hooks/incomeCardConfig.js
// (the canonical copy for this domain). Older copies are NOT re-pointed; the
// Jest test src/lib/sharedOptions.test.js pins them and lists known divergences.
// `ui_card: false` marks values the Calculator form has no card/option for.

export const INCOME_TYPE_OPTIONS = [
  { value: 'employment',              label: 'Employment salary',                 ui_card: true },
  { value: 'self_employment',         label: 'Self-employment / autónomo',        ui_card: true },
  { value: 'partnership_business',    label: 'Business / partnership income',     ui_card: true },
  { value: 'pension',                 label: 'Pension income',                    ui_card: true },
  { value: 'retirement_distribution', label: 'US retirement account withdrawal',  ui_card: true },
  { value: 'dividends',               label: 'Dividends and interest',            ui_card: true },
  { value: 'interest',                label: 'Interest',                          ui_card: false },
  { value: 'capital_gain',            label: 'Capital gains',                     ui_card: true },
  { value: 'rental',                  label: 'Rental income',                     ui_card: true },
  { value: 'other',                   label: 'Other income',                      ui_card: true },
  // Snapshot-only coarse member (plan OQ2): "Investment income (dividends,
  // interest, capital gains)" without saying which. Never rewritten to a guess.
  { value: 'investments_unspecified', label: 'Investment income (type not specified)', ui_card: false },
]

export const INCOME_SUBTYPE_OPTIONS = [
  { value: 'spanish_employer',                       label: 'Spanish employer',                                      income_type: 'employment',              ui_option: true },
  { value: 'foreign_employer_employee',              label: 'Foreign employer (I am an employee)',                   income_type: 'employment',              ui_option: true },
  { value: 'foreign_employer_owner_operated',        label: 'Foreign employer (I own or control this company)',      income_type: 'employment',              ui_option: true },
  { value: 'us_llc_k1',                              label: 'US LLC (K-1 income)',                                   income_type: 'partnership_business',    ui_option: true },
  { value: 'us_s_corp',                              label: 'US S-corp distribution',                                income_type: 'partnership_business',    ui_option: true },
  { value: 'foreign_company_ordinary_distribution',  label: "Distribution from foreign company I don't control",     income_type: 'partnership_business',    ui_option: true },
  { value: 'foreign_company_owner_distribution',     label: 'Distribution from foreign company I own or control',    income_type: 'partnership_business',    ui_option: true },
  { value: 'other_partnership',                      label: 'Other partnership income',                              income_type: 'partnership_business',    ui_option: true },
  { value: 'us_pass_through_unspecified',            label: 'US LLC or S-corp (type not specified)',                 income_type: 'partnership_business',    ui_option: false },
  { value: 'foreign_company_unspecified',            label: 'Foreign company distribution (type not specified)',     income_type: 'partnership_business',    ui_option: false },
  { value: 'spanish_public_pension',                 label: 'Spanish Seguridad Social',                              income_type: 'pension',                 ui_option: true },
  { value: 'spanish_private_pension',                label: 'Spanish private pension plan',                          income_type: 'pension',                 ui_option: true },
  { value: 'foreign_private_pension',                label: 'Foreign private pension',                               income_type: 'pension',                 ui_option: true },
  { value: 'foreign_public_pension',                 label: 'Foreign public (non-government) pension',               income_type: 'pension',                 ui_option: true },
  { value: 'foreign_government_pension',             label: 'Foreign government pension',                            income_type: 'pension',                 ui_option: true },
  { value: 'foreign_pension_non_government_unspecified', label: 'Foreign non-government pension (type not specified)', income_type: 'pension',               ui_option: false },
  { value: 'traditional_401k',                       label: 'Traditional 401(k)',                                    income_type: 'retirement_distribution', ui_option: true },
  { value: 'traditional_ira',                        label: 'Traditional IRA',                                       income_type: 'retirement_distribution', ui_option: true },
  { value: 'roth_401k',                              label: 'Roth 401(k)',                                           income_type: 'retirement_distribution', ui_option: true },
  { value: 'roth_ira',                               label: 'Roth IRA',                                              income_type: 'retirement_distribution', ui_option: true },
  { value: 'other_us_retirement',                    label: 'Other US retirement account',                           income_type: 'retirement_distribution', ui_option: true },
  { value: 'other_foreign_retirement',               label: 'Other foreign retirement account',                      income_type: 'retirement_distribution', ui_option: false },
  { value: 'stock_sale',                             label: 'Stock or fund sale',                                    income_type: 'capital_gain',            ui_option: true },
  { value: 'fund_redemption',                        label: 'Fund redemption',                                       income_type: 'capital_gain',            ui_option: true },
  { value: 'property_sale_primary',                  label: 'Sale of primary residence',                             income_type: 'capital_gain',            ui_option: true },
  { value: 'property_sale_investment',               label: 'Sale of investment property',                           income_type: 'capital_gain',            ui_option: true },
  { value: 'crypto_sale',                            label: 'Crypto sale',                                           income_type: 'capital_gain',            ui_option: true },
  // Rental subtypes are the Calculator's engine vocabulary. A canonical rental
  // item does NOT store one: it is derived from rental_jurisdiction + rental_type
  // (plan D7). They are listed here so the output vocabulary has one definition.
  { value: 'spanish_property_long_term',             label: 'Spanish property — long-term rental',                   income_type: 'rental',                  ui_option: true },
  { value: 'spanish_property_short_term',            label: 'Spanish property — short-term / tourist rental',        income_type: 'rental',                  ui_option: true },
  { value: 'foreign_property',                       label: 'Foreign property',                                      income_type: 'rental',                  ui_option: true },
]

// "Whose income" within the household. NOT record ownership (the database
// ownership column convention is owner_user_id; this is an engine vocabulary key).
export const INCOME_OWNER_OPTIONS = [
  { value: 'self',   label: 'You' },
  { value: 'spouse', label: 'Your spouse' },
]

// The two amount bases the Calculator form offers (incomeCardConfig.js).
export const INCOME_AMOUNT_BASIS_OPTIONS = [
  { value: 'net_entered',   label: 'Net — after expenses' },
  { value: 'gross_entered', label: 'Gross — before expenses' },
]

export const INCOME_PERIOD_OPTIONS = [
  { value: 'annual',   label: 'per year' },
  { value: 'monthly',  label: 'per month' },
  { value: 'one_time', label: 'one-time' },
]

export const INCOME_CURRENCY_OPTIONS = [
  { value: 'EUR', label: 'EUR (€)' },
  { value: 'USD', label: 'USD ($)' },
  { value: 'GBP', label: 'GBP (£)' },
]

export const INCOME_SOURCE_COUNTRY_OPTIONS = [
  { value: 'ES',    label: 'Spain' },
  { value: 'US',    label: 'United States' },
  { value: 'GB',    label: 'United Kingdom' },
  { value: 'DE',    label: 'Germany' },
  { value: 'FR',    label: 'France' },
  { value: 'OTHER', label: 'Other' },
]

export const ACTIVITY_CLASSIFICATION_OPTIONS = [
  { value: 'profesional',                label: 'Professional activity (consulting, design, liberal profession)' },
  { value: 'empresarial',                label: 'Business activity (selling goods, running a shop or agency)' },
  { value: 'agricola_ganadera_forestal', label: 'Agricultural, livestock, or forestry activity' },
]

export const AUTONOMO_TYPE_OPTIONS = [
  { value: 'individual', label: 'Individual (autónomo persona física)' },
  { value: 'societario', label: 'Through a company I own (autónomo societario)' },
]

// How a rental / self-employment amount was entered (the form's path toggle).
export const EXPENSE_PATH_OPTIONS = [
  { value: 'fast_path_net', label: 'I know my net figure' },
  { value: 'itemized',      label: 'Gross plus itemized expenses' },
]

export const DEPRECIATION_SOURCE_OPTIONS = [
  { value: 'user_entered',                  label: 'I know my annual depreciation amount' },
  { value: 'estimated_from_purchase_price', label: 'Estimate from purchase price (3%)' },
  { value: 'none',                          label: 'Skip depreciation for now' },
]

// Snapshot employment_location_when_earned (slotConfig.js).
export const EMPLOYMENT_WORK_LOCATION_OPTIONS = [
  { value: 'us_only',          label: '🇺🇸 Earned while physically in the US' },
  { value: 'spain_only',       label: '🇪🇸 Earned while physically in Spain' },
  { value: 'both_us_spain',    label: '🇺🇸 + 🇪🇸 Split between US and Spain' },
  { value: 'other_or_unclear', label: 'Other / unclear' },
]

// Rental facts (plan OQ6/OQ7: only these two are stored; no tax rule is
// computed from them in this ticket).
export const RENTAL_JURISDICTION_OPTIONS = [
  { value: 'spain',   label: 'Property in Spain' },
  { value: 'foreign', label: 'Property outside Spain' },
]

export const RENTAL_TYPE_OPTIONS = [
  { value: 'long_term_residential', label: 'Long-term residential rental' },
  { value: 'short_term_tourist',    label: 'Short-term / tourist rental' },
  { value: 'other',                 label: 'Other type of rental' },
]

// Itemized expense keys (the Calculator's RentalExpenses / BusinessExpenses).
export const RENTAL_EXPENSE_KEYS = [
  { value: 'mortgage_interest',   label: 'Mortgage interest' },
  { value: 'insurance',           label: 'Insurance' },
  { value: 'repairs_maintenance', label: 'Repairs / maintenance' },
  { value: 'ibi',                 label: 'IBI / local property tax' },
  { value: 'community_fees',      label: 'Community / HOA fees' },
  { value: 'management_fees',     label: 'Property management fees' },
  { value: 'legal_accounting',    label: 'Legal / accounting fees' },
  { value: 'utilities_owner',     label: 'Utilities paid by you' },
  { value: 'other_expenses',      label: 'Other expenses' },
]

export const BUSINESS_EXPENSE_KEYS = [
  { value: 'professional_services',  label: 'Professional services (gestor, legal)' },
  { value: 'software_subscriptions', label: 'Software and subscriptions' },
  { value: 'workspace',              label: 'Workspace (office, coworking, home office)' },
  { value: 'equipment_supplies',     label: 'Equipment and supplies' },
  { value: 'travel_transport',       label: 'Travel and transportation' },
  { value: 'insurance',              label: 'Insurance' },
  { value: 'marketing',              label: 'Marketing and advertising' },
  { value: 'other_expenses',         label: 'Other business expenses' },
]

// Snapshot "types of income" buckets (slotConfig.js income_types).
export const SNAPSHOT_INCOME_TYPE_OPTIONS = [
  { value: 'employment_es',        label: '🇪🇸 Spanish employment salary' },
  { value: 'employment_us',        label: '🇺🇸 US employment (W-2 or salary)' },
  { value: 'self_employment',      label: 'Self-employment' },
  { value: 'business_partnership', label: 'Business or partnership income (K-1, S-corp, LLC, foreign company)' },
  { value: 'rental',               label: 'Rental income' },
  { value: 'investments',          label: 'Investment income (dividends, interest, capital gains)' },
  { value: 'pension',              label: 'Pension or retirement income' },
  { value: 'none',                 label: 'None of the above' },
]

// INPUT direction: how one Snapshot bucket becomes a canonical item. Keyed by
// the Snapshot value (so `value` is unique). Coarse buckets map to the honest
// coarse member, never to a guessed detailed type (plan OQ2). null = not said.
export const SNAPSHOT_INCOME_TYPE_INPUT_MAP = [
  { value: 'employment_es',        income_type: 'employment',              income_subtype: 'spanish_employer', source_country: 'ES' },
  { value: 'employment_us',        income_type: 'employment',              income_subtype: null,               source_country: 'US' },
  { value: 'self_employment',      income_type: 'self_employment',         income_subtype: null,               source_country: null },
  { value: 'business_partnership', income_type: 'partnership_business',    income_subtype: null,               source_country: null },
  { value: 'rental',               income_type: 'rental',                  income_subtype: null,               source_country: null },
  { value: 'investments',          income_type: 'investments_unspecified', income_subtype: null,               source_country: null },
  { value: 'pension',              income_type: 'pension',                 income_subtype: null,               source_country: null },
]

// Snapshot follow-up location vocabulary (self_employment_country,
// rental_property_location). `pension_value` is the same answer as the
// pension_source question spells it (spanish instead of spain).
export const SNAPSHOT_LOCATION_OPTIONS = [
  { value: 'spain', label: '🇪🇸 Spain',          pension_value: 'spanish' },
  { value: 'us',    label: '🇺🇸 United States',  pension_value: 'us' },
  { value: 'both',  label: '🇺🇸 + 🇪🇸 Both',     pension_value: 'both' },
  { value: 'other', label: '🌍 Another country', pension_value: 'other' },
]

// DATA ONLY, no UI is built in this ticket (plan OQ2): the detailed Calculator
// cards each coarse Snapshot bucket expands to, so the future unified form
// reads one definition instead of hard-coding it. `interest` has no card of its
// own (the dividends card is "Dividends and interest"), so it is not listed.
// Capital gains appear under investments because the Snapshot bucket's own
// label includes them.
export const SNAPSHOT_BUCKET_DETAIL_TYPES = [
  { value: 'employment_es',        detail_types: ['employment'] },
  { value: 'employment_us',        detail_types: ['employment'] },
  { value: 'self_employment',      detail_types: ['self_employment'] },
  { value: 'business_partnership', detail_types: ['partnership_business'] },
  { value: 'rental',               detail_types: ['rental'] },
  { value: 'investments',          detail_types: ['dividends', 'capital_gain'] },
  { value: 'pension',              detail_types: ['pension', 'retirement_distribution'] },
]

// ── Property vocabularies (ticket 046-foundation2c-property, slice 3) ───────

// ONE canonical list of places a person can own or sell property. Used for the
// sale_location fact and, key by key, for the three ownership facts. Labels are
// copied from slotConfig.js property_sale_location (the Snapshot says
// `other_foreign` there and `other_property` for ownership; see the two maps).
export const PROPERTY_LOCATION_OPTIONS = [
  { value: 'spain', label: '🇪🇸 Spain' },
  { value: 'us',    label: '🇺🇸 United States' },
  { value: 'other', label: '🌍 Another country' },
]

// INPUT/OUTPUT direction for the Snapshot's property_ownership multi-select
// (slotConfig.js property_ownership). Keyed by the Snapshot value (unique).
// `none` ("No property owned") is the exclusive option and is handled in code.
export const SNAPSHOT_PROPERTY_OWNERSHIP_MAP = [
  { value: 'spain_property', canonical: 'spain', label: '🇪🇸 Property in Spain' },
  { value: 'us_property',    canonical: 'us',    label: '🇺🇸 Property in the US' },
  { value: 'other_property', canonical: 'other', label: '🌍 Property in another country' },
]

// The Snapshot's property_sale_location single-select (slotConfig.js) and the
// vocabulary tax_year_profiles.property_sale_location stores (spain | us |
// other_foreign), keyed by the legacy value (unique).
export const SNAPSHOT_PROPERTY_SALE_LOCATION_MAP = [
  { value: 'spain',         canonical: 'spain' },
  { value: 'us',            canonical: 'us' },
  { value: 'other_foreign', canonical: 'other' },
]

// The most income items (both owners together) the shared facts accept (ticket
// 064, D5). A single number, defined once here. incomeFacts.ts re-exports it, so
// every server importer keeps importing from incomeFacts.ts; the intake screen
// imports it from the generated browser copy. Lowered from 50 to 20.
export const MAX_INCOME_ITEMS = 20

// Every country a person can name as "outside Spain" for the property they owned
// (ticket 064, amendment 2): ISO 3166-1 alpha-2 code plus English name. Spain (ES)
// is deliberately NOT in the list: the question is asked after "Spain" is its own
// answer. Separate from INCOME_SOURCE_COUNTRY_OPTIONS (six coarse values for the
// income card's source field): do not merge them.
export const COUNTRY_OPTIONS = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AX', label: 'Åland Islands' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BQ', label: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Island' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'British Indian Ocean Territory' },
  { value: 'BN', label: 'Brunei' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'CC', label: 'Cocos (Keeling) Islands' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CD', label: 'Congo (Democratic Republic)' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CI', label: 'Côte d\'Ivoire' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curaçao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czechia' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FK', label: 'Falkland Islands' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'TF', label: 'French Southern Territories' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard Island and McDonald Islands' },
  { value: 'VA', label: 'Holy See' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IM', label: 'Isle of Man' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KP', label: 'Korea (North)' },
  { value: 'KR', label: 'Korea (South)' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Laos' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macao' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Island' },
  { value: 'MK', label: 'North Macedonia' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PN', label: 'Pitcairn Islands' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RE', label: 'Réunion' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russia' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'BL', label: 'Saint Barthélemy' },
  { value: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'MF', label: 'Saint Martin (French part)' },
  { value: 'PM', label: 'Saint Pierre and Miquelon' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Maarten (Dutch part)' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syria' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Türkiye' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks and Caicos Islands' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
  { value: 'UM', label: 'United States Minor Outlying Islands' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'VG', label: 'Virgin Islands (British)' },
  { value: 'VI', label: 'Virgin Islands (U.S.)' },
  { value: 'WF', label: 'Wallis and Futuna' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' },
]

// ── Cross-border vocabularies (ticket 048-foundation2d-crossborder, slice 4) ─

// ONE canonical list of major events: the five the live Snapshot shows plus
// `sold_crypto` (written by the Calculator sync, read by the flag engine, shown
// by no form). `none` is NOT an event: "None of these" means every event the
// person saw is a confirmed false. `in_snapshot_form` says whether today's
// Snapshot shows the option (an unticked option that was NOT shown is never a
// confirmed false). Labels are copied from slotConfig.js major_events except the
// two canonical labels John chose (plan Decision 4): large_investment_sale and
// sold_crypto. The live form keeps its wording until the replicas (slice 2b);
// src/lib/sharedOptions.test.js records the divergence. Values are unchanged.
export const MAJOR_EVENT_OPTIONS = [
  { value: 'sold_property',         label: 'Sold property',                                            in_snapshot_form: true,  in_snapshot_array: true },
  { value: 'retirement_withdrawal', label: 'Took money out of a retirement account (401(k), IRA...)',  in_snapshot_form: true,  in_snapshot_array: true },
  { value: 'large_investment_sale', label: 'Sold stocks, funds or a large investment',                 in_snapshot_form: true,  in_snapshot_array: true },
  { value: 'sold_crypto',           label: 'Sold crypto',                                              in_snapshot_form: false, in_snapshot_array: true },
  { value: 'inheritance_or_gift',   label: 'Received an inheritance or gift',                          in_snapshot_form: true,  in_snapshot_array: true },
  { value: 'rsu_or_options',        label: 'Vested RSUs or exercised stock options',                   in_snapshot_form: true,  in_snapshot_array: true },
  // Added by the Advisor Intake (ticket 064, amendment 2). `in_snapshot_array: false`
  // means the value is NEVER part of the Snapshot major_events array, the flag
  // engine or the Calculator profile sync: eventsFromSnapshot / eventsToSnapshot
  // ignore these seven, so those paths see exactly what they saw before.
  { value: 'worked_for_employer',          label: 'Worked for an employer',                  in_snapshot_form: false, in_snapshot_array: false },
  { value: 'self_employed',                label: 'Self-employed or freelanced',             in_snapshot_form: false, in_snapshot_array: false },
  { value: 'owned_business',               label: 'Owned or partly owned a business',        in_snapshot_form: false, in_snapshot_array: false },
  { value: 'received_rental_income',       label: 'Received rental income',                  in_snapshot_form: false, in_snapshot_array: false },
  { value: 'received_dividends_interest',  label: 'Received dividends or interest',          in_snapshot_form: false, in_snapshot_array: false },
  { value: 'received_pension_income',      label: 'Received pension income',                 in_snapshot_form: false, in_snapshot_array: false },
  { value: 'made_significant_gift',        label: 'Made a significant gift',                 in_snapshot_form: false, in_snapshot_array: false },
]

// The follow-up to `retirement_withdrawal`. The Snapshot's `not_sure` is the
// status `unknown`, not a value. Labels from slotConfig.js.
export const RETIREMENT_WITHDRAWAL_TYPE_OPTIONS = [
  { value: 'traditional', label: 'Traditional (401(k), IRA, or pension)' },
  { value: 'roth',        label: 'Roth (401(k) or IRA)' },
]

// Foreign financial accounts (USD for FBAR), labels from slotConfig.js. `none`
// is a real answer the flags read, not known_zero.
export const FOREIGN_ACCOUNT_BAND_OPTIONS = [
  { value: 'none',         label: "I don't have accounts outside Spain" },
  { value: 'under_10k',    label: 'Under $10,000 / €10,000' },
  { value: 'band_10_50k',  label: '$10,000 – $50,000' },
  { value: 'band_50_200k', label: '$50,000 – $200,000' },
  { value: 'band_200k_1m', label: '$200,000 – $1,000,000' },
  { value: 'over_1m',      label: 'Over $1,000,000' },
]

// Worldwide net worth (EUR for the wealth tax). The Snapshot's `not_sure`
// ("Not sure / prefer not to say") is the status `unknown`, not a value.
export const NET_WORTH_BAND_OPTIONS = [
  { value: 'under_300k',    label: 'Under €300,000' },
  { value: 'band_300_700k', label: '€300,000 – €700,000' },
  { value: 'band_700k_1m',  label: '€700,000 – €1,000,000' },
  { value: 'band_1m_2m',    label: '€1,000,000 – €2,000,000' },
  { value: 'band_2m_3m',    label: '€2,000,000 – €3,000,000' },
  { value: 'over_3m',       label: 'Over €3,000,000' },
]

// DATA ONLY, advice never a fact: which income card an event makes relevant.
// One row per link, read in BOTH directions (event -> card, and an income item ->
// the event; the reverse equals calculatorProfileSync.ts 217-230). `strength`:
// clean = one honest card, ambiguous = a person could reasonably need another
// card or none. `income_subtypes` is what the card suggests (empty = card type
// only). `implied_by` says how the reverse direction works: 'subtype' = an item
// of one of income_subtypes implies the event (sales); 'any_item' = any item of
// the card type implies it (the sync treats every retirement distribution as a
// withdrawal); 'never' = items do not imply the event (a salary item does not
// say RSUs vested). `inheritance_or_gift` has NO row on purpose: it triggers no
// Calculator card (it stays a reporting event). Adding an event later is one
// MAJOR_EVENT_OPTIONS row plus one row here. `value` is the unique key.
// `covers` (ticket 072) is read ONLY by the advisor case brief, to decide whether an
// income card already says what a ticked event says: 'type' = any card of income_type,
// 'subtype' = a card with one of income_subtypes, 'never' = no card covers it (RSUs: a
// salary card does not say RSUs vested). The server's compareEventsWithIncome does not
// read it, so the client's own "said but missing" nudge is unchanged.
export const MAJOR_EVENT_INCOME_LINKS = [
  // ROW ORDER = the order cards are suggested: work, property, investments, retirement.
  { value: 'worked_for_employer:employment',                event: 'worked_for_employer',   income_type: 'employment',              income_subtypes: [],                                                     strength: 'clean', implied_by: 'never', covers: 'type' },
  { value: 'self_employed:self_employment',                 event: 'self_employed',         income_type: 'self_employment',         income_subtypes: [],                                                     strength: 'clean', implied_by: 'never', covers: 'type' },
  { value: 'received_rental_income:rental',                 event: 'received_rental_income', income_type: 'rental',                 income_subtypes: [],                                                     strength: 'clean', implied_by: 'never', covers: 'type' },
  { value: 'sold_property:capital_gain',                    event: 'sold_property',         income_type: 'capital_gain',            income_subtypes: ['property_sale_primary', 'property_sale_investment'], strength: 'clean', implied_by: 'subtype', covers: 'subtype' },
  { value: 'received_dividends_interest:dividends',         event: 'received_dividends_interest', income_type: 'dividends',         income_subtypes: [],                                                     strength: 'clean', implied_by: 'never', covers: 'type' },
  { value: 'large_investment_sale:capital_gain',            event: 'large_investment_sale', income_type: 'capital_gain',            income_subtypes: ['stock_sale', 'fund_redemption'],                      strength: 'clean', implied_by: 'subtype', covers: 'subtype' },
  { value: 'sold_crypto:capital_gain',                      event: 'sold_crypto',           income_type: 'capital_gain',            income_subtypes: ['crypto_sale'],                                        strength: 'clean', implied_by: 'subtype', covers: 'subtype' },
  { value: 'rsu_or_options:employment',                     event: 'rsu_or_options',        income_type: 'employment',              income_subtypes: [],                                                     strength: 'clean', implied_by: 'never', covers: 'never' },
  { value: 'received_pension_income:pension',               event: 'received_pension_income', income_type: 'pension',               income_subtypes: [],                                                     strength: 'clean', implied_by: 'never', covers: 'type' },
  { value: 'retirement_withdrawal:retirement_distribution', event: 'retirement_withdrawal', income_type: 'retirement_distribution', income_subtypes: ['traditional_401k', 'traditional_ira', 'roth_401k', 'roth_ira', 'other_us_retirement'], strength: 'clean', implied_by: 'any_item', covers: 'type' },
]

// Item -> type (ticket 068). Used to DERIVE the Snapshot's retirement type from
// an income card. Deliberately NOT the inverse of RETIREMENT_TYPE_SUBTYPE_MAP
// below: that one files other_us_retirement under traditional for suggestions,
// but a card of unknown kind must never decide the type (no guessing).
export const RETIREMENT_SUBTYPE_TYPE_MAP = [
  { value: 'traditional_401k', type: 'traditional' },
  { value: 'traditional_ira',  type: 'traditional' },
  { value: 'roth_401k',        type: 'roth' },
  { value: 'roth_ira',         type: 'roth' },
]

// Narrows the retirement_distribution suggestion when the type is known.
export const RETIREMENT_TYPE_SUBTYPE_MAP = [
  { value: 'traditional', subtypes: ['traditional_401k', 'traditional_ira', 'other_us_retirement'] },
  { value: 'roth',        subtypes: ['roth_401k', 'roth_ira'] },
]

// ── Intake share consent (ticket 070, Advisor Intake I8) ────────────────────
// The consent sentence a client agrees to when they share their saved intake
// with the advisor linked to their record. "Intake share consent v2": a NEW
// version beside v1 (consentEvents.ts PARTNER_CONSENT_*), never an edit of v1.
// The sentence is exactly C2 in project_docs/legal_wording_reference.md section 5,
// with the advisor's name in place of {advisor}. Approved for build and testing
// only (2026-11-03); NOT yet reviewed by Ana/Curro/counsel. If the wording changes
// it ships as a NEW version ('v3'); do not edit this string once a real-client row
// exists, because every consent_events row must keep the words its client saw.
// The server stores the rendered sentence in consent_events.text_shown; the browser
// shows the same template with the same name.
export const INTAKE_SHARE_CONSENT_VERSION = 'v2'
export const INTAKE_SHARE_CONSENT_TEMPLATE = 'By sharing, you authorise HolaSam to share your Intake answers and contact details with {advisor} so they can follow up with you directly.'

// ── Client / contact name length (ticket 073, Advisor Intake I9) ────────────
// One limit for a person's name typed into the intake: the contact name on the
// share screen and an advisor-created client's name. The server enforces it; the
// browser uses it as the input maxLength.
export const CLIENT_NAME_MAX = 100
